
export const IActors = {
    "Actor 1" : 2,
    "Actor 2" : 1,
    "Actor 3" : 3,
    "Actor 4" : 4   
}


export const getActorMap = () => {
    let val = []
    Object.entries(IActors).forEach(entry => {
        const [key, value ] = entry;
        let o = { label : key , value : value};
        val.push(o);
    });

    return val;   
}

export const getActorByNumber = (id) => {
    let intid = parseInt(id);
    let val = null
    Object.entries(IActors).forEach(entry => {
        const [key, value ] = entry;
         if (value === intid) { 
             val = key;
         }
    });

    return val;
 }


